import { toast } from 'react-toastify';
import ApiBase from "./base";
import i18n from "../translations";
import { jsonToQueryString } from '../shared/utils';

export const _BANNER_URL = "banner";

export async function getBannerList(params) {
    const response = await ApiBase.get(`${_BANNER_URL}?${jsonToQueryString(params)}`);

    return response;
}

export async function getBannerDetail(id) {
    const response = await ApiBase.get(`${_BANNER_URL}/${id}`);

    return response;
}

export async function createBanner(params) {
    const response = await ApiBase.post(`${_BANNER_URL}`, params, { headers: { ['Content-type']: "multipart/form-data" } });
    if (response.success) toast.success(i18n.t("SUCCESS_TO_CREATE_BANNER"))

    return response;
}

export async function updateBanner(id, params) {
    const response = await ApiBase.put(`${_BANNER_URL}/${id}`, params, { headers: { ['Content-type']: "multipart/form-data" } });
    if (response.success) toast.success(i18n.t("SUCCESS_TO_UPDATE_BANNER"))

    return response;
}